export class ModalHorizontalAlignment {
	static Start = 'ml-0'
	static Center = 'mx-auto'
	static End = 'ml-auto'
}

export class ModalVerticalAlignment {
	static Top = 'mt-0'
	static Center = 'my-auto'
	static Bottom = 'mt-auto'
}